export enum ActivityStatus {
    Active = 1,
    Cancelled = 2,
}

export const ActivityStatusLabels: Record<number, string> = {
    [ActivityStatus.Active]: "activity.fields.active",
    [ActivityStatus.Cancelled]: "activity.fields.cancelled",
}